/**************************************************
 * Nombre:       Tarjeta_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, IconButton, Typography} from "@mui/material";
import agave from '../../Recursos/Temporales/agave.svg'
import {FiberManualRecord, KeyboardArrowDown, KeyboardArrowUp} from '@mui/icons-material'
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useState} from "react";

const Tarjeta_Categorias = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: 'white', py: sCell ? 3 : 4, px: 3}}
        >

            <Grid
                onClick={() => setOpen(!open)}
                container size={{xs: 10, sm: 10, md: 8}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 18, fontWeight: 800, lineHeight: 1.1}}>
                    {sCell && <span>
                        <IconButton>
                          {!open ?
                              <KeyboardArrowDown/>
                              :
                              <KeyboardArrowUp/>

                          }
                        </IconButton>
                    </span>
                    }

                    {item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 2, sm: 2, md: 4}} sx={{justifyContent: 'flex-end'}}>
                <img src={agave} width={30}/>
            </Grid>

            <Collapse in={open || masSM} sx={{width: '100%'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{borderTop: 1, borderColor: '#00000050', pt: 2, mt: 2}}
                >

                    {item && item.items.map((it, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: item.md ? 6 : 12}}
                              sx={{justifyContent: 'flex-start'}}>
                            <Typography
                                onClick={() => navigate('/Catalogo/Categoria/' + it.nombre)}
                                sx={{
                                    fontSize: 14,
                                    fontWeight: 500, color: "#00000090", cursor: 'pointer',
                                    '&:hover': {
                                        color: '#000'
                                    }
                                }}>
                                <FiberManualRecord sx={{width: 10, height: 10, pr: 1}}/>
                                {it.nombre}</Typography>
                        </Grid>
                    ))}

                </Grid>
            </Collapse>

        </Grid>
    )

}
export default Tarjeta_Categorias

